import Clipboard from 'clipboard'

export type Response = 'success' | 'error'

export interface ICopyTextEvent {
  action: string
  text: string
  trigger: Element
  clearSelection(): void
}

export interface IClipboardConfig {
  autoSetContainer?: boolean
  appendToBody?: boolean
}

export const copyText = (text: string, container: any, callback: (event: ICopyTextEvent, status: Response) => void, config?: IClipboardConfig, selector?: string | Element | NodeListOf<Element>) => {
  const VueClipboardConfig = {
    autoSetContainer: config?.autoSetContainer ?? true,
    appendToBody: config?.appendToBody ?? true
  }
  const fakeElement = document.createElement('button')
  const selectorElement = VueClipboardConfig.autoSetContainer ? fakeElement : selector
  const clipboard = new Clipboard(selectorElement as Element, {
    text: () => text,
    action: () => 'copy',
    container: container !== undefined ? container : document.body
  })
  clipboard.on('success', (e: ICopyTextEvent) => {
    clipboard.destroy()
    callback(e, 'success')
  })
  clipboard.on('error', (e: ICopyTextEvent) => {
    clipboard.destroy()
    callback(e, 'error')
  })
  if (!VueClipboardConfig.autoSetContainer) return
  if (VueClipboardConfig.appendToBody) document.body.appendChild(fakeElement)
  fakeElement.click()
  if (VueClipboardConfig.appendToBody) document.body.removeChild(fakeElement)
}
